export function withFormIndex<T, U extends T & { originalFormIndex: number }>(array: T[]): Array<U> {
  return array.map((item, originalFormIndex) => ({ ...item, originalFormIndex })) as Array<U>;
}
